import type { WeddingSettings } from '@shared/settings'
import { Seccion, colorSeguro, tieneTexto } from './comunes'

/* ===========================================================================
   Código de vestimenta — explicado, no adivinado.
   La paleta se muestra como círculos con su hex al lado: quien va a comprar
   tela o corbata necesita el número, no solo el color.
   =========================================================================== */

export function hayVestimenta(dressCode: WeddingSettings['dressCode']): boolean {
  return (
    tieneTexto(dressCode.title) ||
    tieneTexto(dressCode.description) ||
    dressCode.palette.some((c) => colorSeguro(c) !== null)
  )
}

export default function Vestimenta({ dressCode }: { dressCode: WeddingSettings['dressCode'] }) {
  const colores = dressCode.palette
    .map((crudo) => colorSeguro(crudo))
    .filter((c): c is string => c !== null)

  return (
    <Seccion
      id="vestimenta"
      eyebrow="Código de vestimenta"
      titulo={tieneTexto(dressCode.title) ? dressCode.title : 'Cómo vestir'}
    >
      {tieneTexto(dressCode.description) && (
        <p className="whitespace-pre-line leading-relaxed text-tinta/85">
          {dressCode.description}
        </p>
      )}

      {colores.length > 0 && (
        <div className="mt-4">
          <p className="eyebrow">Paleta sugerida</p>
          {/* Muestras grandes, como abanico de sastrería: en escritorio son lo
              que llena la sección, no un adorno arrinconado. */}
          <ul className="mt-3 flex flex-wrap gap-6 lg:gap-8">
            {colores.map((color, i) => (
              // El círculo es decorativo: el dato es el hex de abajo, que el
              // lector de pantalla ya lee. Con `role="img"` y el hex por
              // etiqueta lo deletreaba dos veces, letra por letra.
              <li key={`${color}-${i}`} className="flex flex-col items-start gap-2">
                <span
                  aria-hidden="true"
                  title={color}
                  style={{ backgroundColor: color }}
                  className="block size-12 rounded-full ring-1 ring-tinta/15 lg:size-20"
                />
                <span className="tabular font-mono text-xs uppercase text-palo-hondo">{color}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Seccion>
  )
}
